export default "<div #map id=\"map\"></div>\n"